module.exports = "\nfunction requireAll(req, loader = '') {\n\n  return req.keys()\n  .filter((key) => key.indexOf('-sample.') >= 0)\n  .reduce((memo, key) => {\n    const name = key.replace(/.\\/\\d+-sample./, '').replace('.js', '')\n    memo[name] = req(`${loader}${key}`)\n    return memo\n  }, {})\n}\n\n\nconst examples = requireAll(require.context('./', true, /\\.js$/))\nconst codes = requireAll(require.context('!!raw!./', true, /\\.js$/), '')\n\nmodule.exports = { examples, codes }\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/showcases/index.js
 ** module id = 258
 ** module chunks = 0
 **/